// BaseWeb.jsx
import React, { useEffect, useState } from 'react';
import { View, Image, ActivityIndicator, Text } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import { useNavigation, useRoute } from '@react-navigation/native';
import styles from '../../web/styles/homeWebStyles';
import SidebarMenu from '../web/../components/SidebarMenu';

export default function BaseWeb({ children }) {
    const navigation = useNavigation();
    const route = useRoute();

    const [usuarioId, setUsuarioId] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verificarLoginEBuscarDados = async () => {
            const id = await AsyncStorage.getItem('usuario_id');
            if (!id) {
                navigation.navigate('LoginWeb');
                return;
            }

            setUsuarioId(id);

            try {
                const response = await axios.get(`https://api.imogo.com.br/api/v1/corretores/${id}`);
                setUserInfo(response.data);
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }

            setLoading(false);
        };

        verificarLoginEBuscarDados();
    }, [navigation]);

    const handleNavigate = (path) => {
        navigation.navigate(path);
    };

    const handleLogout = async () => {
        await AsyncStorage.removeItem('usuario_id');
        navigation.navigate('LoginWeb');
    };

    if (loading) {
        return (
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <ActivityIndicator size="large" color="#730d83" />
            </View>
        );
    }

    return (
        <View style={styles.container}>
            {/* Sidebar */}
            <View style={styles.sidebarMinimal}>
                <Image
                    source={require('../../assets/img/go_logo.png')}
                    style={styles.sidebarLogo}
                />
                <SidebarMenu
                    currentPath={route.name}
                    onNavigate={handleNavigate}
                    onLogout={handleLogout}
                />
            </View>

            {/* Área principal */}
            {/* <View style={{ flex: 1, padding: 40 }}> */}
                {typeof children === 'function' ? children(userInfo) : children}
            {/* </View> */}
        </View>
    );
}
